var bruteforceMatcher = () => {
  return null;
};
export { bruteforceMatcher as default };
